module.exports = "/images/vendor/desiigner-svg/svg/logoipsum/logoipsum-12.svg?30068ea37aa893ff405babb7785e205b";